import { Helper } from '../../Helper';
export class GetObjectPropertyHelperBase extends Helper {
    emit(sb, node, options) {
        sb.emitOp(node, 'OVER');
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.findObjectProperty({
            accessor: () => {
                sb.emitPushInt(node, 0);
                sb.emitOp(node, 'PICKITEM');
                sb.emitHelper(node, options, sb.helpers.invokeCall({ bindThis: true, noArgs: true }));
            },
            dataExists: () => {
                sb.emitOp(node, 'NIP');
                if (options.pushValue) {
                    sb.emitPushInt(node, 0);
                    sb.emitOp(node, 'PICKITEM');
                }
                else {
                    sb.emitOp(node, 'DROP');
                }
            },
            data: () => {
                sb.emitOp(node, 'DROP');
                if (options.pushValue) {
                    sb.emitHelper(node, options, sb.helpers.wrapUndefined);
                }
            },
            getObject: this.getObject.bind(this),
        }));
    }
}

//# sourceMappingURL=GetObjectPropertyHelperBase.js.map
